module.exports = __webpack_public_path__ + "static/rf-screenshot-recommend-51ef6fdabc2ea81d1ef846038614711f.jpg";